import * as THREE from 'three';
import { ModelInModelTree } from '../../components/cms/model-space/model-space';

/**
 * Létrehoz egy modelfát a paraméterben megadott modelekkből, és UUID-t ad az egyes "modelleknek" a "userData"-ban lévő UUID-t, ha van,
 * ha nincs, akkor generál és hozzáadja a "userData"-hoz.
 * @param models
 * @returns ModelInModelTree[]
 */
export const createModelTreeInModelSpace = (models: THREE.Object3D[]): ModelInModelTree[] => {
    return models.map(model => {
        let uuid = model.userData?.uuid;
        if (!uuid) {
            uuid = THREE.MathUtils.generateUUID();
            model.userData = { ...model.userData, uuid };
        }
        
        model.uuid = uuid;
    
        return {
            uuid,
            name: model.name,
            visible: model.visible,
            isRoot: false,
            position: [model.position.x, model.position.y, model.position.z],
            rotation: [model.rotation.x, model.rotation.y, model.rotation.z],
            scale: [model.scale.x, model.scale.y, model.scale.z],
            originalMaterial: model.material ? model.material.clone() as THREE.Material : undefined,
            children: createModelTreeInModelSpace(model.children)
        };
    });
};